class Config {
  static getEnvironment() {
    return process.env.REACT_APP_ENV || 'development'
  }

  static getBaseUrl() {
    if (this.isProd()) {
      return 'https://www.epharma.dghealthcare.online/api/pharmacystore/'
    }

    if (this.isUat()) {
      return 'https://www.epharma-uat.dghealthcare.online/api/pharmacystore/'
    }

    if (this.isStaging()) {
      return 'https://pharma-be.dpdigitalstaging.com/api/pharmacystore/'
    }

    if (this.isDev()) {
      return 'https://www.epharma-dev.dghealthcare.online/api/pharmacystore/'
    }

    return 'http://localhost:8080/api/pharmacystore/'
  }

  static getMediaBaseUrl() {
    if (this.isProd()) {
      return 'https://www.epharma.dghealthcare.online'
    }

    if (this.isUat()) {
      return 'https://www.epharma-uat.dghealthcare.online'
    }

    if (this.isStaging()) {
      return 'https://pharma-be.dpdigitalstaging.com'
    }

    if (this.isDev()) {
      return 'https://www.epharma-dev.dghealthcare.online'
    }

    return 'http://localhost:8080'
  }

  static getFullImageUrl(imagePath) {
    if (!imagePath) return ''
    if (imagePath.startsWith('http')) return imagePath
    
    const baseUrl = this.getMediaBaseUrl()
    
    let cleanPath = imagePath
    if (!cleanPath.startsWith('/media/') && !cleanPath.startsWith('media/')) {
      cleanPath = `/media/${cleanPath}`
    } else if (cleanPath.startsWith('media/')) {
      cleanPath = `/${cleanPath}`
    } else if (!cleanPath.startsWith('/')) {
      cleanPath = `/${cleanPath}`
    }
    
    return `${baseUrl}${cleanPath}`
  }

  static isStaging() {
    const env = this.getEnvironment()
    return env === 'staging'
  }

  static isDev() {
    const env = this.getEnvironment()
    return env === 'dev'
  }

  static isUat() {
    const env = this.getEnvironment()
    return env === 'uat'
  }

  static isProd() {
    const env = this.getEnvironment()
    return env === 'prod'
  }
}

export default Config
